<template>
  <span>
    <div v-if="isAdmin" :style="{position: 'absolute',top: 0,bottom: 0, 'overflow-y': 'scroll', right: 0, left: 0,'overflow-x': 'hidden'}">
      <v-card class="cardStyle" max-width="400" style=" margin: auto;margin-top: 10px; padding: 10px">
        <v-card-title style="justify-content: center">
          {{ $t('Pay exchange transactions') }}
        </v-card-title>
        <v-divider style="background: black" />
        <v-row v-for="transaction in remainingExchangetransactions" :key="transaction.transaction._id">
          <v-col v-if="transaction.transaction.type == constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING" cols="12" style="text-align: right;align-self: center">
            <!-- Give bytos to the user -->
            {{ transaction.stripe }}
            <v-card-text>
              <form>
                <h3>Amount: <span>{{ transaction.transaction.amountReceive }}</span></h3>
                <v-btn class="btn-primary" dark @click="payTransactionCrypto(transaction.user.walletAddress, transaction.transaction.amountReceive, transaction.transaction._id)">
                  {{ $t('Pay with crypto') }}
                </v-btn>
              </form>
            </v-card-text>
          </v-col>
          <v-col v-if="transaction.transaction.type == constants.FACTORING_PAYMENT_METHODS.CRYPTO" cols="12" style="text-align: right;align-self: center">
            <!-- Give eurs to the user -->
            <PaymentComponent :amount="transaction.transaction.amountReceive" :id-form="'Form'+transaction.transaction._id" :id-card="'Card'+transaction.transaction._id" :id-btn="'Btn'+transaction.transaction._id" :user="transaction.user" @success="onSuccessTransaction(transaction.transaction._id)" />
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div v-else :style="{position: 'absolute',top: 0,bottom: 0, 'overflow-y': 'scroll', right: 0, left: 0,'overflow-x': 'hidden'}">
      <v-card class="cardStyle" max-width="400" style=" margin: auto;margin-top: 10px">
        <v-card-title style="justify-content: center">
          {{ $t('Buy bytos') }}
        </v-card-title>
        <v-divider style="background: black" />
        <v-row>
          <v-col cols="6" style="text-align: right;align-self: center">
            {{ $t('Amount €') }}:
          </v-col>
          <v-col style="text-align: left">
            <v-text-field v-model="amountEur" type="number" min="0" style="margin-left: 10px" @input="payStripe = false" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" style="text-align: right">
            {{ $t("You'll receive") }}:
          </v-col>
          <v-col style="text-align: left">
            <span v-if="exangeRatios && exangeRatios.eurToByto">{{ amountEur * exangeRatios.eurToByto }}B </span>
            <span v-else>0B </span>
          </v-col>
        </v-row>
        <v-divider style="background: black" />
        <v-card-actions style="justify-content: center;flex-direction: column; align-items: center; align-content: center;">
          <v-row>
            <v-col cols="12" style="text-align: center;align-self: center">
              <v-btn class="btn-primary" dark @click="payStripe = amountEur > 0">
                {{ $t('Pay') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row style="width: 100%;">
            <v-col cols="12" style="text-align: right;align-self: center">
              <PaymentComponent v-if="payStripe" :amount="amountEur" :user="{stripePublickey: platformAccounts.stripe.public_key, _id: 'platform' }" @success="onSuccess(constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING, amountEur, amountEur * exangeRatios.eurToByto)" @cancel="payStripe = false" />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>

      <v-card class="cardStyle"
              max-width="400" style=" margin: auto;margin-top: 10px">
        <v-card-title style="justify-content: center">
          {{ $t('Buy euros') }}
        </v-card-title>
        <v-divider style="background: black" />
        <v-row>
          <v-col cols="6" style="text-align: right;align-self: center">
            {{ $t('Amount bytos') }}:
          </v-col>
          <v-col style="text-align: left">
            <v-text-field v-model="amountBytos" type="number" min="0" style="margin-left: 10px" @input="payStripe = false" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" style="text-align: right">
            {{ $t("You'll receive") }}:
          </v-col>
          <v-col style="text-align: left">
            <span v-if="exangeRatios && exangeRatios.eurToByto">{{ getNumber(amountBytos / exangeRatios.eurToByto) }}€ </span>
            <span v-else>0€ </span>
          </v-col>
        </v-row>
        <v-divider style="background: black" />
        <v-card-actions style="justify-content: center;flex-direction: column; align-items: center; align-content: center;">
          <v-row>
            <v-col cols="12" style="text-align: center;align-self: center">
              <v-btn class="btn-primary" dark @click="payCrypto(platformAccounts.walletAddress, amountBytos)">
                {{ $t('Pay with crypto') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </span>
</template>

<script>

import ApiRepository from "@/repositories/ApiRepository";
import PaymentComponent from "../components/Payment";
import Constants from "../../constants";
import Hash from "object-hash";
import SmartRepository from "../repositories/SmartRepository";

export default {
    name: "Exchange",
    components: {PaymentComponent},
    data () {
        return {
            remainingExchangetransactions: [],
            isAdmin: false,
            constants: Constants,
            platformAccounts: null,
            payStripe: false,
            exangeRatios: null,
            amountEur: 0,
            amountBytos: 0
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        getNumber (val) {
            return val.toFixed(2);
        },
        fetch () {
            this.isAdmin = this.$user && this.$user.role === Constants.USER.ROLE_ADMIN;
            ApiRepository.getRemainingTransactions().then((transactions) => {
                console.log(transactions.data.transactions);
                this.remainingExchangetransactions = transactions.data.transactions;
            });
            ApiRepository.getExangeRatios().then((ratios) => {
                this.exangeRatios = ratios.data.exangeRatios;
            });
            ApiRepository.getPlatformPublicAccounts().then((accounts) => {
                this.platformAccounts = accounts.data.accounts;
            });
            if (!this.isAdmin) {
                this.$root.$emit('show-confirmation-modal', {
                    title: this.$t('Warning'),
                    message: this.$t('You will receive the eurs to the stripe account in the configuration in profile.\n' +
                      'You will receive the bytos to the wallet in the configuration in profile'),
                    yesText: "OK",
                    noText: "profile",
                    no: () => {
                        this.$router.push({name: 'profile', replace: true});
                    }
                });
            }
        },
        onSuccess (type, amountPayed, amountReceive) {
            ApiRepository.addExchangeTransaction(type, amountPayed, amountReceive).then(() => {
                this.$root.$emit('show-snackbar', {message: this.$t('Payed correctly')});
                this.payStripe = false;
                this.amountEur = 0;
                this.amountBytos = 0;
            });
        },
        payCrypto (wallet, amount) {
            SmartRepository.transaction(Constants.contractByto, "transfer", [wallet, SmartRepository.parseEther(amount)]).then(() => {
                this.onSuccess(Constants.FACTORING_PAYMENT_METHODS.CRYPTO, amount, this.getNumber(this.amountBytos / this.exangeRatios.eurToByto));
            }).catch((err) => {
                console.log("ERROR: " + err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
            });
        },
        onSuccessTransaction (id) {
            ApiRepository.updateTransaction(id).then(() => {
                this.$root.$emit('show-snackbar', {message: this.$t('Payed correctly')});
                this.fetch();
            });
        },
        payTransactionCrypto (wallet, amount, id) {
            SmartRepository.transaction(Constants.contractByto, "transfer", [wallet, SmartRepository.parseEther(amount)]).then(() => {
                this.onSuccessTransaction(id);
            }).catch((err) => {
                console.log("ERROR: " + err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
            });
        },
    }
};
</script>

<style scoped>

</style>
